import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "top-0 bg-black-header drop-shadow-xl flex w-full items-center h-20" }
const _hoisted_2 = { class: "flex w-60" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "xr-icon-developers whitespace-nowrap text-4xl" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path3" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path4" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path5" })
], -1)
const _hoisted_4 = { class: "text-gray-text text-xs" }
const _hoisted_5 = { class: "flex-grow" }
const _hoisted_6 = { class: "flex flex-row-reverse mr-10 tablet:mr-0 tablet:flex-row tablet:justify-between items-center" }
const _hoisted_7 = { class: "text-white capitalize hidden tablet:block" }
const _hoisted_8 = { class: "flex flex-row-reverse items-center" }
const _hoisted_9 = { class: "hidden tablet:block relative" }
const _hoisted_10 = { class: "inline-block relative border-2 border-gray-text rounded-full w-11 bottom-0 h-11 left-0 p-1" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Account")
const _hoisted_12 = { class: "block relative" }
const _hoisted_13 = { class: "hidden tablet:block relative" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://developers.xarcade.io/",
    target: "_blank"
  }, "Developer Docs")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://t.me/+M-CAzgGY3DliY2Fl",
    target: "_blank"
  }, "Help Desk")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://xarcade.io/#FAQ",
    target: "_blank"
  }, "FAQs")
], -1)
const _hoisted_17 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "block relative" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1)
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "arrow-up" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", null, "Click on the bulb icon to learn more", -1)
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { class: "tablet:grid tablet:grid-cols-12 p-4" }
const _hoisted_26 = { class: "tablet:col-span-2 p-5 text-center" }
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "col-span-4 p-2 tablet:p-5" }
const _hoisted_29 = { class: "text-md table:text-2xl text-gray-200 mb-2 font-semibold" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-text text-sm tablet:text-md" }, " We're here to guide you towards the completion of your account setup. From here, you'll also learn how to release your first game. ", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h6", { class: "mt-5 text-gray-200 font-semibold text-sm uppercase mb-2" }, "Your current onboarding status", -1)
const _hoisted_32 = { class: "text-gray-text text-sm tablet:text-md mt-2" }
const _hoisted_33 = { class: "text-gray-text text-sm tablet:text-md mt-2" }
const _hoisted_34 = { class: "progress mt-5" }
const _hoisted_35 = { class: "col-span-6" }
const _hoisted_36 = { class: "tablet:grid tablet:grid-cols-2" }
const _hoisted_37 = { class: "p-2 tablet:p-5 tablet:border-l tablet:border-black-border" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h5", { class: "text-sm tablet:text-2xl text-gray-200 mb-2 font-semibold" }, "Step 1", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-200 mb-2 font-semibold" }, "Account Setup", -1)
const _hoisted_40 = { class: "text-sm tablet:text-md text-gray-200" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "inline-block" }, "Register developer account", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "inline-block" }, "Verify Email", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "inline-block" }, "Edit Public Profile", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "inline-block" }, "Complete Personal Information", -1)
const _hoisted_45 = { class: "p-2 tablet:p-5 tablet:border-l tablet:border-black-border" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("h5", { class: "text-sm tablet:text-2xl text-gray-200 mb-2 font-semibold" }, "Step 2", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-200 mb-2 font-semibold" }, "Release and Test", -1)
const _hoisted_48 = { class: "text-sm tablet:text-md text-gray-300" }
const _hoisted_49 = { class: "inline-block" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = /*#__PURE__*/_createTextVNode("in ")
const _hoisted_52 = /*#__PURE__*/_createTextVNode("Settings")
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "inline-block" }, "Create a game", -1)
const _hoisted_54 = { class: "inline-block" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = /*#__PURE__*/_createTextVNode("in ")
const _hoisted_57 = /*#__PURE__*/_createTextVNode("Create token page")
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "inline-block" }, "Upload game version", -1)
const _hoisted_59 = { class: "inline-block" }
const _hoisted_60 = { class: "p-2 tablet:p-5 tablet:border-l tablet:border-black-border" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("h5", { class: "text-sm tablet:text-2xl text-gray-200 mb-2 font-semibold" }, "Step 3", -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-200 mb-2 font-semibold" }, "Game on", -1)
const _hoisted_63 = { class: "text-sm tablet:text-md text-gray-300" }
const _hoisted_64 = { class: "inline-block" }
const _hoisted_65 = { class: "inline-block" }
const _hoisted_66 = { class: "inline-block" }
const _hoisted_67 = { class: "hidden tablet:block relative" }
const _hoisted_68 = /*#__PURE__*/_createTextVNode("  Create")
const _hoisted_69 = { class: "flex" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "inline-block flex-grow-0" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "xr-icon-game text-blue-primary text-2xl relative -top-2 my-2" })
], -1)
const _hoisted_71 = /*#__PURE__*/_createTextVNode("Games")
const _hoisted_72 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-text" }, "Start creating new game", -1)
const _hoisted_74 = [
  _hoisted_71,
  _hoisted_72,
  _hoisted_73
]
const _hoisted_75 = { class: "flex" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "inline-block flex-grow-0" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "xr-icon-token text-blue-primary text-2xl relative -top-2 my-2" })
], -1)
const _hoisted_77 = /*#__PURE__*/_createTextVNode("Tokens")
const _hoisted_78 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-text" }, "Add tokens to your game", -1)
const _hoisted_80 = {
  key: 0,
  class: "fixed inset-0 bg-black-primary bg-opacity-50 transition-opacity"
}
const _hoisted_81 = {
  key: 0,
  class: "fixed z-50 inset-0 overflow-y-auto"
}
const _hoisted_82 = { class: "flex items-center justify-center min-h-full p-1 text-center sm:p-0" }
const _hoisted_83 = { class: "relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-2 sm:max-w-md w-full m-2" }
const _hoisted_84 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_85 = { class: "modal-content bg-black-body text-white" }
const _hoisted_86 = { class: "modal-body p-10 text-justify z-50 relative" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-300 text-md mb-5 text-center font-bold" }, "Create New Games", -1)
const _hoisted_88 = { class: "border-0 pb-1" }
const _hoisted_89 = { class: "flex justify-between items-center my-4" }
const _hoisted_90 = { class: "step" }
const _hoisted_91 = { class: "inline-block" }
const _hoisted_92 = { class: "step" }
const _hoisted_93 = { class: "inline-block" }
const _hoisted_94 = { class: "stepper-content p-5 bg-black-primary w-full rounded-md" }
const _hoisted_95 = { key: 0 }
const _hoisted_96 = { class: "form-group mb-2" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", {
  for: "email",
  class: "text-sm mb-2 text-white"
}, "Enter Game Title", -1)
const _hoisted_98 = {
  key: 0,
  class: "text-danger-primary"
}
const _hoisted_99 = {
  key: 1,
  "aria-labelledby": "step2-trigger"
}
const _hoisted_100 = { class: "form-group mb-2" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-white mb-2" }, " Selected Namespace ", -1)
const _hoisted_102 = { class: "items-center bg-black-body flex p-2" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("div", { class: "h-10 w-10 flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "xr-icon-namespace",
    style: {"font-size":"25px"}
  })
], -1)
const _hoisted_104 = {
  key: 0,
  class: "text-sm text-gray-text"
}
const _hoisted_105 = /*#__PURE__*/_createElementVNode("div", null, "No Namespace", -1)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("div", { class: "mt-1 text-xs" }, "selected for this game", -1)
const _hoisted_107 = [
  _hoisted_105,
  _hoisted_106
]
const _hoisted_108 = {
  key: 1,
  class: "text-sm text-gray-text overflow-hidden ml-1"
}
const _hoisted_109 = { class: "truncate" }
const _hoisted_110 = { class: "mt-1" }
const _hoisted_111 = { class: "ps-0 mt-3 text-sm text-white" }
const _hoisted_112 = /*#__PURE__*/_createTextVNode(" Select from below to link ")
const _hoisted_113 = /*#__PURE__*/_createTextVNode(" to an available ")
const _hoisted_114 = { class: "text-yellow-bar" }
const _hoisted_115 = /*#__PURE__*/_createTextVNode(" Namespaces: ")
const _hoisted_116 = {
  key: 0,
  class: "my-3"
}
const _hoisted_117 = /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin h-3 w-3 mr-3 bg-yellow-500 inline-block",
  viewBox: "0 0 24 24"
}, null, -1)
const _hoisted_118 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 text-sm" }, "Fetching namespaces", -1)
const _hoisted_119 = [
  _hoisted_117,
  _hoisted_118
]
const _hoisted_120 = { class: "px-0 text-gray-text" }
const _hoisted_121 = {
  key: 0,
  class: "mt-2 text-sm"
}
const _hoisted_122 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://developers.xarcade.io/docs/Onboarding/testnet_namespace",
    target: "_blank",
    class: "text-xs text-gray-300 hover:text-white underline"
  }, "Create new namespace guide")
], -1)
const _hoisted_123 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_124 = /*#__PURE__*/_createTextVNode("Settings")
const _hoisted_125 = ["onClick"]
const _hoisted_126 = { class: "mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_layoutHomeAutoSignQRModal = _resolveComponent("layoutHomeAutoSignQRModal")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "relative w-36 mx-4",
        to: {name: 'viewDashboard'}
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.appVersion), 1)
    ]),
    _createElementVNode("button", {
      class: "navbar-toggler tablet:hidden w-6 h-6",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenuInMobile && _ctx.toggleMenuInMobile(...args)))
    }, [
      _createVNode(_component_font_awesome_icon, {
        icon: "fa-solid fa-bars",
        class: "w-full h-full text-gray-text hover:text-white transition-all duration-200"
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h5", _hoisted_7, _toDisplayString(this.$route.meta.title), 1),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("a", {
              class: "flex items-center cursor-pointer mr-4",
              id: "profileDiv",
              onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.resetDropDown('profile'); _ctx.isDropDown.profile = !_ctx.isDropDown.profile}),
              onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOverDropDown.profile = true)),
              onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isOverDropDown.profile = false))
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: "bg-cover bg-center bg-black-body w-full h-full rounded-full",
                  style: _normalizeStyle({ 'background-image': `url(${_ctx.image})` })
                }, null, 4)
              ])
            ], 32),
            _createVNode(_Transition, {
              "enter-active-class": "transition ease-out duration-100",
              "enter-from-class": "transform opacity-0 scale-95",
              "enter-to-class": "transform opacity-100 scale-100",
              "leave-active-class": "transition ease-in duration-75",
              "leave-from-class": "transform opacity-100 scale-100",
              "leave-to-class": "transform opacity-0 scale-95"
            }, {
              default: _withCtx(() => [
                (_ctx.isDropDown.profile)
                  ? (_openBlock(), _createElementBlock("ul", {
                      key: 0,
                      id: "dropDownProfieDiv",
                      class: "dropdown-options text-white absolute top-10 -left-14 bg-black-header drop-shadow-lg z-20 w-32",
                      onMouseover: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isOverDropDown.profile = true)),
                      onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isOverDropDown.profile = false))
                    }, [
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, {
                          to: { name : 'viewAccount' },
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isDropDown.profile = false))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent"]))
                        }, "Sign Out")
                      ])
                    ], 32))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("a", {
              class: "mr-6",
              href: "#",
              onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => {_ctx.resetDropDown('notification'); _ctx.isDropDown.notification = !_ctx.isDropDown.notification}, ["prevent"])),
              id: "notificationDisplay"
            }, [
              _createElementVNode("span", {
                class: "xr-icon-bell text-gray-text text-2xl",
                onMouseover: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isOverDropDown.notification = true)),
                onMouseleave: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isOverDropDown.notification = false))
              }, null, 32)
            ]),
            _createVNode(_Transition, {
              "enter-active-class": "transition ease-out duration-100",
              "enter-from-class": "transform opacity-0 scale-95",
              "enter-to-class": "transform opacity-100 scale-100",
              "leave-active-class": "transition ease-in duration-75",
              "leave-from-class": "transform opacity-100 scale-100",
              "leave-to-class": "transform opacity-0 scale-95"
            }, {
              default: _withCtx(() => [
                (_ctx.isDropDown.notification)
                  ? (_openBlock(), _createElementBlock("ul", {
                      key: 0,
                      id: "dropDownNotificationDiv",
                      class: "dropdown-options text-white absolute top-10 -left-32 bg-black-header drop-shadow-lg z-20 w-48",
                      onMouseover: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isOverDropDown.notification = true)),
                      onMouseleave: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isOverDropDown.notification = false))
                    }, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.isDropDown.notification = false), ["prevent"]))
                        }, " No Notifications")
                      ])
                    ], 32))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("a", {
              class: "mr-6",
              href: "#",
              onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => {_ctx.resetDropDown('help'); _ctx.isDropDown.guide = !_ctx.isDropDown.guide}, ["prevent"]))
            }, [
              _createElementVNode("span", {
                class: "xr-icon-question-mark text-gray-text text-2xl",
                onMouseover: _cache[14] || (_cache[14] = ($event: any) => (_ctx.isOverDropDown.guide = true)),
                onMouseleave: _cache[15] || (_cache[15] = ($event: any) => (_ctx.isOverDropDown.guide = false))
              }, null, 32)
            ]),
            _createVNode(_Transition, {
              "enter-active-class": "transition ease-out duration-100",
              "enter-from-class": "transform opacity-0 scale-95",
              "enter-to-class": "transform opacity-100 scale-100",
              "leave-active-class": "transition ease-in duration-75",
              "leave-from-class": "transform opacity-100 scale-100",
              "leave-to-class": "transform opacity-0 scale-95"
            }, {
              default: _withCtx(() => [
                (_ctx.isDropDown.guide)
                  ? (_openBlock(), _createElementBlock("ul", {
                      key: 0,
                      id: "dropDownHelpDiv",
                      class: "dropdown-options text-white absolute top-10 -left-40 bg-black-header drop-shadow-lg z-20 w-48",
                      onMouseover: _cache[17] || (_cache[17] = ($event: any) => (_ctx.isOverDropDown.guide = true)),
                      onMouseleave: _cache[18] || (_cache[18] = ($event: any) => (_ctx.isOverDropDown.guide = false))
                    }, _hoisted_17, 32))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", {
              class: "mr-6",
              type: "button",
              onMouseover: _cache[21] || (_cache[21] = ($event: any) => (_ctx.isOverDropDown.onBoarding = true)),
              onMouseleave: _cache[22] || (_cache[22] = ($event: any) => (_ctx.isOverDropDown.onBoarding = false))
            }, [
              _createElementVNode("span", {
                class: "xr-icon-bulb text-2xl",
                onClick: _cache[19] || (_cache[19] = ($event: any) => {_ctx.hideToolTip(); _ctx.resetDropDown('onBoard'); _ctx.isDropDown.onBoarding = !_ctx.isDropDown.onBoarding})
              }, _hoisted_21),
              (_ctx.showToolTip)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "tooltip-custom drop-shadow-md",
                    onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.hideToolTip && _ctx.hideToolTip(...args)))
                  }, _hoisted_24))
                : _createCommentVNode("", true)
            ], 32),
            _createVNode(_Transition, {
              "enter-active-class": "transition ease-out duration-100",
              "enter-from-class": "transform opacity-0 scale-95",
              "enter-to-class": "transform opacity-100 scale-100",
              "leave-active-class": "transition ease-in duration-75",
              "leave-from-class": "transform opacity-100 scale-100",
              "leave-to-class": "transform opacity-0 scale-95"
            }, {
              default: _withCtx(() => [
                (_ctx.isDropDown.onBoarding)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      id: "onboardingDropdown",
                      class: "text-white fixed tablet:absolute pb-14 tablet:p-0 m-auto left-0 tablet:left-auto top-16 tablet:top-10 tablet:-right-36 bg-black-header drop-shadow-lg z-20 w-full h-full tablet:h-auto overflow-y-auto tablet:w-200",
                      onMouseover: _cache[26] || (_cache[26] = ($event: any) => (_ctx.isOverDropDown.onBoarding = true)),
                      onMouseleave: _cache[27] || (_cache[27] = ($event: any) => (_ctx.isOverDropDown.onBoarding = false))
                    }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "absolute right-3 top-3 hover:bg-gray-700 w-8 h-8 items-center rounded-md text-sm",
                        onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.isDropDown.onBoarding = false))
                      }, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "fa-solid fa-close",
                          class: "text-gray-text p-0 text-end inline-block text-sm"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("img", {
                            src: _ctx.onboarding,
                            class: "inline-block w-20 tablet:w-auto"
                          }, null, 8, _hoisted_27)
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, "Welcome aboard, " + _toDisplayString(_ctx.firstname) + "!", 1),
                          _hoisted_30,
                          _hoisted_31,
                          _createElementVNode("p", _hoisted_32, " There are a few more steps for you to complete, " + _toDisplayString(_ctx.firstname) + ". Gamers are waiting for your game to be released! ", 1),
                          _createElementVNode("p", _hoisted_33, " The below progress bar is amber colored because this is the color that represents the " + _toDisplayString(_ctx.testnetLabel) + " environment and will be incomplete upon the release of your " + _toDisplayString(_ctx.testnetLabel) + " game because of your remaining mainnetLabel release steps to complete which are not available yet ", 1),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", {
                              class: "progress-bar",
                              role: "progressbar",
                              style: _normalizeStyle({width: _ctx.onboardingProgress.toString() + '%'}),
                              "aria-valuenow": "25",
                              "aria-valuemin": "0",
                              "aria-valuemax": "100"
                            }, _toDisplayString(_ctx.onboardingProgress.toString() + '%'), 5)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              _hoisted_38,
                              _hoisted_39,
                              _createElementVNode("ul", _hoisted_40, [
                                _createElementVNode("li", {
                                  id: "onboarding-0",
                                  class: _normalizeClass(["flex items-center mb-1", !_ctx.onboardingChecklist[0] ? 'text-gray-text': ''])
                                }, [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: "fa-solid fa-check",
                                    class: _normalizeClass(["text-sm tablet:text-md inline-block mr-2", !_ctx.onboardingChecklist[0] ? 'text-gray-text': 'text-success-check'])
                                  }, null, 8, ["class"]),
                                  _hoisted_41
                                ], 2),
                                _createElementVNode("li", {
                                  id: "onboarding-1",
                                  class: _normalizeClass(["flex items-center mb-1", !_ctx.onboardingChecklist[1] ? 'text-gray-text': ''])
                                }, [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: "fa-solid fa-check",
                                    class: _normalizeClass(["text-sm tablet:text-md inline-block mr-2", !_ctx.onboardingChecklist[1] ? 'text-gray-text': 'text-success-check'])
                                  }, null, 8, ["class"]),
                                  _hoisted_42
                                ], 2),
                                _createElementVNode("li", {
                                  id: "onboarding-2",
                                  class: _normalizeClass(["flex items-center mb-1", !_ctx.onboardingChecklist[2] ? 'text-gray-text': ''])
                                }, [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: "fa-solid fa-check",
                                    class: _normalizeClass(["text-sm tablet:text-md inline-block mr-2", !_ctx.onboardingChecklist[2] ? 'text-gray-text': 'text-success-check'])
                                  }, null, 8, ["class"]),
                                  _hoisted_43
                                ], 2),
                                _createElementVNode("li", {
                                  id: "onboarding-3",
                                  class: _normalizeClass(["flex items-center mb-1", !_ctx.onboardingChecklist[3] ? 'text-gray-text': ''])
                                }, [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: "fa-solid fa-check",
                                    class: _normalizeClass(["text-sm tablet:text-md inline-block mr-2", !_ctx.onboardingChecklist[3] ? 'text-gray-text': 'text-success-check'])
                                  }, null, 8, ["class"]),
                                  _hoisted_44
                                ], 2)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              _hoisted_46,
                              _hoisted_47,
                              _createElementVNode("ul", _hoisted_48, [
                                _createElementVNode("li", {
                                  id: "onboarding-4",
                                  class: _normalizeClass(["flex items-center mb-1", !_ctx.onboardingChecklist[4] ? 'text-gray-text': ''])
                                }, [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: "fa-solid fa-check",
                                    class: _normalizeClass(["text-sm tablet:text-md inline-block mr-2", !_ctx.onboardingChecklist[4] ? 'text-gray-text': 'text-success-check'])
                                  }, null, 8, ["class"]),
                                  _createElementVNode("div", _hoisted_49, [
                                    _createTextVNode("Sirius " + _toDisplayString(_ctx.testnetLabel) + " Wallet Setup ", 1),
                                    (!_ctx.onboardingChecklist[4])
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_50, [
                                          _hoisted_51,
                                          _createVNode(_component_router_link, {
                                            to: { name: 'viewHomeSettings' },
                                            class: "text-blue-primary hover:underline duration-200 transition-all",
                                            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.isDropDown.onBoarding = false))
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_52
                                            ]),
                                            _: 1
                                          })
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 2),
                                _createElementVNode("li", {
                                  id: "onboarding-5",
                                  class: _normalizeClass(["flex items-center mb-1", !_ctx.onboardingChecklist[5] ? 'text-gray-text': ''])
                                }, [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: "fa-solid fa-check",
                                    class: _normalizeClass(["text-sm tablet:text-md inline-block mr-2", !_ctx.onboardingChecklist[5] ? 'text-gray-text': 'text-success-check'])
                                  }, null, 8, ["class"]),
                                  _hoisted_53
                                ], 2),
                                _createElementVNode("li", {
                                  id: "onboarding-6",
                                  class: _normalizeClass(["flex items-center mb-1", !_ctx.onboardingChecklist[6] ? 'text-gray-text': ''])
                                }, [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: "fa-solid fa-check",
                                    class: _normalizeClass(["text-sm tablet:text-md inline-block mr-2", !_ctx.onboardingChecklist[6] ? 'text-gray-text': 'text-success-check'])
                                  }, null, 8, ["class"]),
                                  _createElementVNode("div", _hoisted_54, [
                                    _createTextVNode("Create Token in " + _toDisplayString(_ctx.testnetLabel) + " ", 1),
                                    (!_ctx.onboardingChecklist[4])
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_55, [
                                          _hoisted_56,
                                          _createVNode(_component_router_link, {
                                            to: { name: 'viewTokensCreate', params: { network: 'testnet' } },
                                            class: "text-blue-primary hover:underline duration-200 transition-all",
                                            onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.isDropDown.onBoarding = false))
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_57
                                            ]),
                                            _: 1
                                          })
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 2),
                                _createElementVNode("li", {
                                  id: "onboarding-7",
                                  class: _normalizeClass(["flex items-center mb-1", !_ctx.onboardingChecklist[7] ? 'text-gray-text': ''])
                                }, [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: "fa-solid fa-check",
                                    class: _normalizeClass(["text-sm tablet:text-md inline-block mr-2", !_ctx.onboardingChecklist[7] ? 'text-gray-text': 'text-success-check'])
                                  }, null, 8, ["class"]),
                                  _hoisted_58
                                ], 2),
                                _createElementVNode("li", {
                                  id: "onboarding-8",
                                  class: _normalizeClass(["flex items-center mb-1", !_ctx.onboardingChecklist[8] ? 'text-gray-text': ''])
                                }, [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: "fa-solid fa-check",
                                    class: _normalizeClass(["text-sm tablet:text-md inline-block mr-2", !_ctx.onboardingChecklist[8] ? 'text-gray-text': 'text-success-check'])
                                  }, null, 8, ["class"]),
                                  _createElementVNode("div", _hoisted_59, "Release game in " + _toDisplayString(_ctx.testnetLabel), 1)
                                ], 2)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_60, [
                            _hoisted_61,
                            _hoisted_62,
                            _createElementVNode("ul", _hoisted_63, [
                              _createElementVNode("li", {
                                id: "onboarding-4",
                                class: _normalizeClass(["flex items-center mb-1", !_ctx.onboardingChecklist[9] ? 'text-gray-text': ''])
                              }, [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "fa-solid fa-check",
                                  class: _normalizeClass(["text-sm tablet:text-md inline-block mr-2", !_ctx.onboardingChecklist[9] ? 'text-gray-text': 'text-success-check'])
                                }, null, 8, ["class"]),
                                _createElementVNode("div", _hoisted_64, "Sirius " + _toDisplayString(_ctx.mainnetLabel) + " Wallet Setup", 1)
                              ], 2),
                              _createElementVNode("li", {
                                id: "onboarding-6",
                                class: _normalizeClass(["flex items-center mb-1", !_ctx.onboardingChecklist[11] ? 'text-gray-text': ''])
                              }, [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "fa-solid fa-check",
                                  class: _normalizeClass(["text-sm tablet:text-md inline-block mr-2", !_ctx.onboardingChecklist[11] ? 'text-gray-text': 'text-success-check'])
                                }, null, 8, ["class"]),
                                _createElementVNode("div", _hoisted_65, "Create Token in " + _toDisplayString(_ctx.mainnetLabel), 1)
                              ], 2),
                              _createElementVNode("li", {
                                id: "onboarding-8",
                                class: _normalizeClass(["flex items-center mb-1", !_ctx.onboardingChecklist[12] ? 'text-gray-text': ''])
                              }, [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "fa-solid fa-check",
                                  class: _normalizeClass(["text-sm tablet:text-md inline-block mr-2", !_ctx.onboardingChecklist[12] ? 'text-gray-text': 'text-success-check'])
                                }, null, 8, ["class"]),
                                _createElementVNode("div", _hoisted_66, "Release game in " + _toDisplayString(_ctx.mainnetLabel), 1)
                              ], 2)
                            ])
                          ])
                        ])
                      ])
                    ], 32))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("button", {
              onClick: _cache[28] || (_cache[28] = _withModifiers(($event: any) => {_ctx.resetDropDown('create'); _ctx.isDropDown.create = !_ctx.isDropDown.create}, ["prevent"])),
              id: "createOptionButton",
              class: "text-white bg-black-body p-1.5 px-3 rounded-md mr-6 relative opacity-75 hover:opacity-100 transition-all duration-200",
              type: "button",
              onMouseover: _cache[29] || (_cache[29] = ($event: any) => (_ctx.isOverDropDown.create = true)),
              onMouseleave: _cache[30] || (_cache[30] = ($event: any) => (_ctx.isOverDropDown.create = false))
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: "fa-solid fa-plus",
                class: "text-white inline-block"
              }),
              _hoisted_68
            ], 32),
            (_ctx.isDropDown.create)
              ? (_openBlock(), _createElementBlock("ul", {
                  key: 0,
                  class: "dropdown-options-create text-white absolute top-10 -left-36 bg-black-header drop-shadow-lg z-20 w-60",
                  onMouseover: _cache[33] || (_cache[33] = ($event: any) => (_ctx.isOverDropDown.create = true)),
                  onMouseleave: _cache[34] || (_cache[34] = ($event: any) => (_ctx.isOverDropDown.create = false))
                }, [
                  _createElementVNode("li", _hoisted_69, [
                    _hoisted_70,
                    _createElementVNode("a", {
                      href: "#",
                      class: "flex-grow inline-block",
                      onClick: _cache[31] || (_cache[31] = _withModifiers(($event: any) => {_ctx.isDisplayCreateGameModal = true; _ctx.isDropDown.create = false;}, ["prevent"]))
                    }, _hoisted_74)
                  ]),
                  _createElementVNode("li", _hoisted_75, [
                    _hoisted_76,
                    _createVNode(_component_router_link, {
                      to: { name: 'viewTokensCreate', params: { network: 'testnet' } },
                      class: "flex-grow inline-block",
                      onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.isDropDown.create = false))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_77,
                        _hoisted_78,
                        _hoisted_79
                      ]),
                      _: 1
                    })
                  ])
                ], 32))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-100",
      "enter-from-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-from-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.isDisplayCreateGameModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_80))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-100",
      "enter-from-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-from-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.isDisplayCreateGameModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "absolute right-2 top-2 hover:bg-gray-700 w-8 h-8 items-center rounded-md text-sm",
                          onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.isDisplayCreateGameModal = false)),
                          id: "closeCreateGameModal"
                        }, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-close",
                            class: "text-gray-text p-0 text-end inline-block text-sm"
                          })
                        ]),
                        _hoisted_87,
                        _createElementVNode("div", _hoisted_88, [
                          _createElementVNode("div", _hoisted_89, [
                            _createElementVNode("div", _hoisted_90, [
                              _createElementVNode("button", {
                                onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.jumpToStep(1))),
                                class: "text-center w-20",
                                id: "step1-trigger"
                              }, [
                                _createElementVNode("div", _hoisted_91, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["rounded-full bg-black-primary mb-3 items-center flex justify-center h-11 w-11 text-white", { 'bg-blue-primary': _ctx.stepper.step1 }])
                                  }, "1", 2)
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["step-label text-gray-text text-sm text-center", { 'text-white': _ctx.stepper.step1 }])
                                }, "Enter Name", 2)
                              ])
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["h-1 w-14 border-t-2 border-black-border relative -top-3", { activeStep: _ctx.stepper.step2 }])
                            }, null, 2),
                            _createElementVNode("div", _hoisted_92, [
                              _createElementVNode("button", {
                                onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.jumpToStep(2))),
                                class: "step-trigger w-20",
                                id: "step2-trigger"
                              }, [
                                _createElementVNode("div", _hoisted_93, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["rounded-full bg-black-primary mb-3 items-center flex justify-center h-11 w-11 text-white", { 'bg-blue-primary': _ctx.stepper.step2 }])
                                  }, "2", 2)
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["step-label text-gray-text text-sm text-center", { 'text-white': _ctx.stepper.step2 }])
                                }, "Namespace", 2)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_94, [
                            (_ctx.stepper.step1 == true && _ctx.stepper.step2 == false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                  _createElementVNode("div", _hoisted_96, [
                                    _hoisted_97,
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      class: "form-control outline-none px-3 py-2 rounded-md text-white border-0 w-full bg-black-body",
                                      id: "game-title",
                                      placeholder: "Game Title",
                                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.state.gameTitle) = $event))
                                    }, null, 512), [
                                      [_vModelText, _ctx.state.gameTitle]
                                    ])
                                  ]),
                                  (_ctx.v$.gameTitle.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_98, _toDisplayString(_ctx.v$.gameTitle.$errors[0].$message), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.stepper.step2 == true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                  _createElementVNode("div", _hoisted_100, [
                                    _hoisted_101,
                                    _createElementVNode("div", _hoisted_102, [
                                      _hoisted_103,
                                      (_ctx.namespaces.selectedNamespace.domain === '' && _ctx.namespaces.selectedNamespace.namespaceId === '')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_104, _hoisted_107))
                                        : _createCommentVNode("", true),
                                      (_ctx.namespaces.selectedNamespace.domain !== '' && _ctx.namespaces.selectedNamespace.namespaceId !== '')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                            _createElementVNode("div", _hoisted_109, _toDisplayString(_ctx.namespaces.selectedNamespace.domain), 1),
                                            _createElementVNode("div", _hoisted_110, _toDisplayString(_ctx.namespaces.selectedNamespace.namespaceId), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_111, [
                                      _hoisted_112,
                                      _createElementVNode("b", null, _toDisplayString(_ctx.state.gameTitle), 1),
                                      _hoisted_113,
                                      _createElementVNode("span", _hoisted_114, _toDisplayString(_ctx.testnetLabel), 1),
                                      _hoisted_115
                                    ]),
                                    (_ctx.isShowFetchingNamespace)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_116, _hoisted_119))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("ul", _hoisted_120, [
                                      (_ctx.namespaces.namespacesList === '')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                                            _createTextVNode(" No available " + _toDisplayString(_ctx.testnetLabel) + " namespaces ", 1),
                                            _hoisted_122
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.isNamespaceError)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                                            _createTextVNode("Error fetching namespace. Please make sure Sirius " + _toDisplayString(_ctx.testnetLabel) + " Wallet is connected in the ", 1),
                                            _createVNode(_component_router_link, {
                                              to: { name: 'viewHomeSettings' },
                                              class: "text-blue-primary hover:underline transition-all duration-200",
                                              onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.isDisplayCreateGameModal = false))
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_124
                                              ]),
                                              _: 1
                                            })
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.namespaces.namespacesList, (namespace) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                          class: "my-2 text-sm hover:text-white duration-200 transition-all cursor-pointer overflow-hidden truncate",
                                          key: namespace,
                                          onClick: ($event: any) => (_ctx.chooseNamespace(namespace))
                                        }, _toDisplayString(namespace.name), 9, _hoisted_125))
                                      }), 128))
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_126, [
                          (_ctx.stepper.step1 == true && _ctx.stepper.step2 == false)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn-primary",
                                onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.jumpToStep(2)))
                              }, "Next"))
                            : _createCommentVNode("", true),
                          (_ctx.stepper.step2 == true)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: _normalizeClass([[_ctx.namespaces.selectedNamespace.domain == '' ? 'opacity50' : ''], "btn-primary"]),
                                onClick: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.createGame && _ctx.createGame(...args)))
                              }, " Finish ", 2))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_layoutHomeAutoSignQRModal, {
      qr: _ctx.qr,
      title: _ctx.title,
      message: _ctx.message,
      isQRModalShow: _ctx.isQRModalOpened,
      onCloseModel: _cache[42] || (_cache[42] = ($event: any) => (_ctx.closeModal())),
      onConfirmedButtonPressedAutoSign: _cache[43] || (_cache[43] = ($event: any) => (_ctx.closeModal()))
    }, null, 8, ["qr", "title", "message", "isQRModalShow"])
  ]))
}